















































import { Component, Prop, Vue } from 'vue-property-decorator'
import dayjs from '@/plugins/dayjs'
import isBetween from 'dayjs/plugin/isBetween'
dayjs.extend(isBetween)
import {
  ClinicResponse,
  MedicalTreatmentSpot,
  Spot,
  SpotRequest
} from '@/interface/api'
import { formatDate } from '@/utils/index'
import { DateFormat } from '@/utils/constants'
@Component({})
export default class TreatmentSpotSelectTemplate extends Vue {
  @Prop({ default: () => null }) private clinic!: ClinicResponse
  @Prop({ default: 30 }) private perMinute!: number
  @Prop({ default: () => [] }) private publicHolidyList!: string[]
  @Prop({ default: 0 }) private reservationType!: number
  @Prop({ default: () => null }) private medicalTreatmentSpotMap!: Map<
    string,
    Spot[]
  >

  @Prop({ default: () => [] })
  private medicalTreatmentSpots!: MedicalTreatmentSpot[]

  private get targetDates(): {
    labelDate: string
    labelWeekday: string
    date: string
  }[] {
    const dates = this.medicalTreatmentSpots.map(treatmentSpot => {
      return {
        labelDate: formatDate(new Date(treatmentSpot.day), DateFormat.D),
        labelWeekday: formatDate(new Date(treatmentSpot.day), DateFormat.dd),
        date: treatmentSpot.day
      }
    })
    return dates
  }

  private getWeekDateColor = (dayOfWeek: string, value: string) => {
    switch (dayOfWeek) {
      case '日':
        return '#CE1F1F'
      case '土':
        return '#1A67AE'
    }
    const formated = formatDate(new Date(value), DateFormat.YYYY_MM_DD_HYPHEN)
    // 祝日判定
    const isHoliday = this.publicHolidyList.includes(formated)
    if (isHoliday) {
      return '#CE1F1F'
    }
    return '#80868b'
  }

  private get treatmentSpotTimes(): string[] {
    if (!this.clinic.business_hours || this.clinic.business_hours.length === 0) {
      return []
    }

    const interval = this.perMinute // 分単位の間隔（柔軟に変更可能）

    // 最も早い open_time と 最も遅い close_time を取得
    const minOpenTime = this.clinic.business_hours.reduce((earliest, bh) => {
      const time = dayjs(`2000/01/01 ${bh.open_time}`)
      return time.isBefore(earliest) ? time : earliest
    }, dayjs(`2000/01/01 23:59`))

    const maxCloseTime = this.clinic.business_hours.reduce((latest, bh) => {
      const time = dayjs(`2000/01/01 ${bh.close_time}`)
      return time.isAfter(latest) ? time : latest
    }, dayjs(`2000/01/01 00:00`))

    const availableTimes: string[] = []
    let currentTime = minOpenTime.clone()

    while (currentTime.isBefore(maxCloseTime)) {  // close_time は含めない
      // 現在の時刻がいずれかの business_hours 内にあるかチェック
      const isWithinBusinessHours = this.clinic.business_hours.some(bh => {
        const open = dayjs(`2000/01/01 ${bh.open_time}`)
        const close = dayjs(`2000/01/01 ${bh.close_time}`)
        return currentTime.isBetween(open, close, null, '[)'); // close_time は含めない
      })

      if (isWithinBusinessHours) {
        availableTimes.push(currentTime.format('HH:mm'))
      }

      currentTime = currentTime.add(interval, 'minute')
    }

    return availableTimes
  }

  private isAvailableSpot(date: string, spotTime: string): boolean {
    if (
      this.clinic.clinic.holiday_flag &&
      this.publicHolidyList.includes(
        formatDate(new Date(date), DateFormat.YYYY_MM_DD_HYPHEN)
      )
    )
      return false
    const hourMinute = spotTime.split(':')
    let spotTimeCondition = spotTime
    switch (hourMinute[1]) {
      case '10':
      case '20':
        spotTimeCondition = hourMinute[0] + ':' + '00'
        break
      case '40':
      case '50':
        spotTimeCondition = hourMinute[0] + ':' + '30'
        break
    }
    const targetMedicalTreatmentSpot = this.medicalTreatmentSpots.find(
      medicalTreatmentSpot => medicalTreatmentSpot.day === date
    )
    const targetSpot = targetMedicalTreatmentSpot!.spots.find(
      spot =>
        formatDate(new Date(spot.spot_datetime), DateFormat.HH_mm) ===
        spotTimeCondition
    )
    if (!targetSpot) return false
    switch (hourMinute[1]) {
      case '00':
      case '30':
        return targetSpot.first_unit_available > 0
      case '10':
      case '40':
        return targetSpot.second_unit_available > 0
      case '20':
      case '50':
        return targetSpot.third_unit_available > 0
      default:
        return false
    }
  }

  private selectTreatmentSpot(date: string, spotTime: string) {
    const hourMinute = spotTime.split(':')
    let spotTimeCondition = spotTime
    switch (hourMinute[1]) {
      case '10':
      case '20':
        spotTimeCondition = hourMinute[0] + ':' + '00'
        break
      case '40':
      case '50':
        spotTimeCondition = hourMinute[0] + ':' + '30'
        break
    }
    const targetMedicalTreatmentSpot = this.medicalTreatmentSpotMap.get(
      formatDate(date, DateFormat.YYYY_MM_DD)
    )
    const targetSpot = targetMedicalTreatmentSpot!.find(
      spot =>
        formatDate(spot.spot_datetime, DateFormat.HH_mm) === spotTimeCondition
    )
    const spotDatetime = new Date(targetSpot!.spot_datetime)
    spotDatetime.setMinutes(Number(hourMinute[1]))
    const spotRequest: SpotRequest = {
      id: targetSpot!.id,
      spot_datetime: spotDatetime.toString()
    }
    if (this.reservationType) spotRequest.range_time = targetSpot!.range_time
    this.$emit('on-treatment-spot-select', date, spotRequest)
  }
}
